import { throttle } from 'lodash/fp';

export const throttle500 = throttle(500);
